import type { ReactNode } from 'react';
import type { WellnessSlide } from '@lighthouse/shared';
import { WellnessCarousel } from './WellnessCarousel';
import { WellnessSlidePhoto } from './WellnessSlidePhoto';

interface WellnessHeroBannerProps {
  headline: string;
  subline?: string;
  badge?: string;
  actions?: ReactNode;
  slides?: WellnessSlide[];
  /** Static abstract background when no carousel */
  staticSlide?: WellnessSlide;
  variant?: 'client' | 'therapist' | 'admin' | 'visitor';
}

export function WellnessHeroBanner({
  headline,
  subline,
  badge,
  actions,
  slides,
  staticSlide,
  variant = 'client',
}: WellnessHeroBannerProps) {
  const hasCarousel = slides && slides.length > 0;

  return (
    <section className={`wellness-hero-banner wellness-hero-banner-${variant}`}>
      <div className="wellness-hero-banner-bg" aria-hidden>
        {hasCarousel ? (
          <WellnessCarousel
            slides={slides}
            showCaptions={false}
            compact
            autoPlay
            className="wellness-hero-banner-carousel"
          />
        ) : staticSlide ? (
          <WellnessSlidePhoto slide={staticSlide} />
        ) : null}
        <div className="wellness-hero-banner-overlay" />
      </div>
      <div className="wellness-hero-banner-content">
        {badge ? <span className="wellness-hero-badge">{badge}</span> : null}
        <h1 className="wellness-hero-headline">{headline}</h1>
        {subline ? <p className="wellness-hero-subline">{subline}</p> : null}
        {actions ? <div className="wellness-hero-actions">{actions}</div> : null}
      </div>
    </section>
  );
}
